import { useEffect } from "react";
import {
  COMMAND_PRIORITY_CRITICAL,
  INSERT_LINE_BREAK_COMMAND,
  INSERT_PARAGRAPH_COMMAND,
  KEY_ENTER_COMMAND,
} from "lexical";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";

/**
 * Prevents line breaks and new paragraphs when the editor
 * is configured for single-line input.
 */
export const SingleLinePlugin = (): null => {
  const [editor] = useLexicalComposerContext();

  // Returning true from a command handler tells Lexical the command is
  // "handled" and should not propagate — effectively swallowing the event.
  // CRITICAL priority ensures these run before any other handlers.
  useEffect((): (() => void) => {
    const unregisterEnter: () => void = editor.registerCommand(
      KEY_ENTER_COMMAND,
      () => true,
      COMMAND_PRIORITY_CRITICAL
    );
    const unregisterParagraph: () => void = editor.registerCommand(
      INSERT_PARAGRAPH_COMMAND,
      () => true,
      COMMAND_PRIORITY_CRITICAL
    );
    const unregisterLineBreak: () => void = editor.registerCommand(
      INSERT_LINE_BREAK_COMMAND,
      () => true,
      COMMAND_PRIORITY_CRITICAL
    );

    return (): void => {
      unregisterEnter();
      unregisterParagraph();
      unregisterLineBreak();
    };
  }, [editor]);

  return null;
};
